import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AlertSuccess = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 28, height: 28, fill: 'none', ...props.sx }}
    data-testid="alertSuccessIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.3334 13.4993C27.3334 20.8631 21.3639 26.8327 14.0001 26.8327C6.63628 26.8327 0.666748 20.8631 0.666748 13.4993C0.666748 6.13555 6.63628 0.166016 14.0001 0.166016C21.3639 0.166016 27.3334 6.13555 27.3334 13.4993ZM6.23221 15.1825C5.92271 14.8618 5.92271 14.3549 6.23221 14.0342L7.45195 12.7701C7.77941 12.4307 8.32462 12.4307 8.65208 12.7701L11.7515 15.9822C11.8334 16.067 11.9697 16.067 12.0516 15.9822L19.3481 8.42054C19.6755 8.08117 20.2208 8.08117 20.5482 8.42054L21.768 9.6846C22.0775 10.0053 22.0775 10.5122 21.768 10.833L12.0516 20.9024C11.9697 20.9872 11.8334 20.9872 11.7515 20.9024L6.23221 15.1825Z"
      fill="#00844D"
    />
  </SvgIcon>
);

export default AlertSuccess;
